module.exports = __webpack_public_path__ + "static/media/dot_white_filled.88817ede.svg";